import React from 'react';

import { useField } from 'react-final-form';

import { messages } from '@qality/common-messages';
import {
  ProjectService,
  StorageOfUniqueServices,
} from '@qality/common-service';

import { ProjectSelectErrorView } from './ProjectSelectError.view';

export const ProjectSelectError = () => {
  const { input, meta } = useField('project');

  const handleGoToConfigurationLink = async () => {
    try {
      const project = await ProjectService.getProject(
        input.value?.key || input.value
      );
      window.open(
        StorageOfUniqueServices.get('URLService').getProjectConfigIssueTypesUrl(
          project
        ),
        '_blank'
      );
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleCriticalError(
        e,
        messages['error.import.goToConfiguration.message'],
        plugin.servicedeskUrl
      );
    }
  };

  return (
    <ProjectSelectErrorView
      handleGoToConfigurationLink={handleGoToConfigurationLink}
      meta={meta}
    />
  );
};
